// form fixes
const observer = new MutationObserver(() => {
    const label = document.querySelector('form.g-container label[tabindex="0"]');
    if (label) {
        label.removeAttribute('tabindex');
    }

    const removeBtn = document.querySelector('div[data-file-remove]');
    if (removeBtn) {
        removeBtn.setAttribute('tabindex', '0');
        removeBtn.setAttribute('role', 'button'); // for screen readers

        // Allow Enter/Space to activate it
        removeBtn.addEventListener('keydown', (e) => {
            if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                removeBtn.click();   // simulate click, triggers plugin removal
                document.querySelector('.gfb__dropzone--placeholder--button').focus();
            }
        });            
    }
});
observer.observe(document.body, { childList: true, subtree: true });

// mp4 playback toggle button
document.addEventListener('DOMContentLoaded', () => {
    const origin = document.querySelector('.hero__media-container');
    const video = origin.parentElement.parentElement.querySelector('video');
    const btn = document.querySelector('div.video-playback-toggle button');

    if (btn, video) {
        btn.addEventListener('click', () => {
            // console.log('toggle play/pause')
            if (video.paused) {
                video.play();
                btn.className = "video-playback-toggle--pause";
            }
            else {
                video.pause();            
                btn.className = "video-playback-toggle--play";
            }

            video.controls = false;
        });
    }
});

// a11y debug, highlight currently tabbed element
// (function () {
//     let last;

//     document.addEventListener("focusin", e => {
//         // Remove outline from previously focused element
//         if (last) last.style.outline = "";

//         // Add outline to new focused element
//         e.target.style.outline = "3px solid red";
//         last = e.target;
//     });
// })();